import { RouteProp, useRoute } from '@react-navigation/native';
import { LayoutContext, ScreenSize } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { BillPaymentStackParamList, BillPaymentStackRoutes } from '../../payment.navigator';
import { BillPaymentSuccessMobileComponent } from './BillPaymentSuccessMobile.component';
import { BillPaymentSuccessWebComponent } from './BillPaymentSuccessWeb.component';

export const BillPaymentSuccessScreen: React.FC = () => {
  const layout = useContext(LayoutContext);
  const route = useRoute<RouteProp<BillPaymentStackParamList, BillPaymentStackRoutes.Success>>();
  const { request, response, submitResponse, debitAccount, documentSelected, paymentType, userFee } = route.params;

  if (layout.screenSize === ScreenSize.Tablet || layout.isMobile) {
    return (
      <BillPaymentSuccessMobileComponent
        request={request}
        response={response}
        debitAccount={debitAccount}
        submitResponse={submitResponse}
        documentSelected={documentSelected}
        paymentType={paymentType}
        userFee={userFee}
      />
    );
  }
  return (
    <BillPaymentSuccessWebComponent
      request={request}
      response={response}
      debitAccount={debitAccount}
      submitResponse={submitResponse}
      documentSelected={documentSelected}
      paymentType={paymentType}
      userFee={userFee}
    />
  );
};
